import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../shared/providers/rest.service';

@Injectable()

export class AnalyticsService extends RestService {

  GetTenantDistribution(input: any) {
    return this.post('analytics/tenantdistribution', input);
  }

  GetActiveListingAskingPrice(input: any) {
    return this.post('analytics/ActiveListingAskingPrice', input);
  }

  GetCompActiveListingAskingPrice(input: any) {
    return this.post('analytics/CompActiveListingAskingPrice', input);
  }

  GetCompRemaingTermList(input: any): Observable<any[]> {
    return this.post<any>('analytics/CompRemaingTermList', input);
  }

  GetTenantSubcategoryComparison(input: any) {
    return this.post('analytics/GetTenantSubcategoryComparison', input);
  }

  GetTypeAndSubcategoryOfProperty(input: any) {
    return this.post('analytics/GetTypeAndSubcategoryOfProperty', input);
  }

  GetCompComparisonData(input: any) {
    return this.post('analytics/compcomparison', input);
  }

  GetSubcategoryDistribution(input: any) {
    return this.post('analytics/GetSubcategoryDistribution', input);
  }

  GetAnalyticsDetails(input: any) {
    return this.post('analytics/GetAnalyticsDetails', input);
  }

  GetCompAnalyticsDetails(input: any) {
    return this.post('analytics/GetCompAnalyticsDetails', input);
  }

  GetPropertyDates(propertyId: any) {
    return this.get('analytics/GetPropertyDates/' + propertyId);
  }

  GetTenantBreakdown(input: any) {
    return this.post('analytics/tenantbreakdown', input);
  }

  GetMarketDatatSummary(input: any) {
    return this.post('analytics/marketdatatsummary', input);
  }

  GetCompMarketDatatSummary(input: any) {
    return this.post('analytics/compmarketdatatsummary', input);
  }

  GetTenantsOfProperties(input: any) {
    return this.post('analytics/tenantsOfProperties', input);
  }

  GetLineChartData(input: any) {
    return this.post('analytics/LineChartData', input);
  }

  GetWatchList(userId: number,UserGuid:string) {
    return this.GET('analytics/getWatchList/' + userId + '/' + UserGuid);

  }

  GetPortfoliochartData(userId: number, userGuid: string) {
    return this.GET('analytics/getMarketChart/' + userId + '/' + userGuid);
  }

  GetMarketchartTypeDataForPreviousMonths() {
    return this.GET('analytics/getMarketChartByTypesUptoPreviousMonth');
  }
  GetMarketchartTypeCurrentMonths() {
    return this.GET('analytics/getMarketChartByTypesInCurrentMonth');
  }

  GetMarketChartByTypes(userId: number) {
    return this.GET('analytics/getMarketChartByTypes/' + userId);
  }

  GetMyPropertiesList(userId: number, userGuid: string) {
    return this.GET('analytics/GetMyPropertiesList/' + userId + '/' + userGuid);
  } 

  //// Get Avg CapRate Chart Detail
  GetAvgCapRateChartDetail(id: string) {
    return this.GET('dataentryproperty/GetAvgCapRateChartDetail/' + id);
  }

  //// Get Avg CapRate Chart Detail For AssetType
  GetAvgCapRateChartDetailForAssetType(id: string) {
    return this.GET('analytics/GetAvgCapRateChartDetailForAssetType/' + id);
  }

  //// Get Avg CapRate Chart Detail For AssetType
  GetAvgCapRateChartDetailForSubCategoryType(id: string) {
    return this.GET('analytics/GetAvgCapRateChartDetailForSubCategoryType/' + id);
  }

}
